'use client'

// The client half of identity, now privy-free: the SDK is megabytes of
// wallet stack, so it lives in the auth island (PrivyIsland.jsx, loaded
// lazily by AuthIsland) and publishes through the store. Everything on
// the boot path asks these two things and pays nothing for them:
//
//   useAccount() — { ready, signedIn, username, called, logout }
//   authFetch()  — fetch with the privy token attached once the island is
//                  up; before that it goes out bare, and the drawers'
//                  signedIn-keyed refetches recover the difference

import useGameStore from '../../stores/gameStore'

export const HAS_AUTH = !!process.env.NEXT_PUBLIC_PRIVY_APP_ID

export async function authFetch(url, opts = {}) {
  const getToken = useGameStore.getState().authApi?.getToken
  let token = null
  if (getToken) {
    try { token = await getToken() } catch { /* signed out */ }
  }
  const headers = { ...(opts.headers || {}) }
  if (token) headers.Authorization = `Bearer ${token}`
  return fetch(url, { ...opts, headers })
}

export function useAccount() {
  const identity = useGameStore((s) => s.identity)
  const ready = useGameStore((s) => s.authReady)
  const signedIn = useGameStore((s) => s.authSignedIn)
  return {
    ready,
    signedIn,
    username: identity?.username || null,
    // The settings name, when one is set: the name he actually USES. The
    // generated username above stays the id.
    called: identity?.called || null,
    logout: () => useGameStore.getState().authApi?.logout?.(),
  }
}
